module.exports = __webpack_public_path__ + "img/reward_point2.754585fc.png";